import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import isTimeSuggestionsEnabled from '../utils/isTimeSuggestionsEnabled';

export default function shouldShowTimeSuggestions(formId: string) {
    const fullComposeViewState = getFullComposeViewState(formId);
    const timeSuggestionsEnabled = isTimeSuggestionsEnabled(formId);

    if (fullComposeViewState) {
        return !fullComposeViewState.isAcceptProposeNewTime && timeSuggestionsEnabled;
    }

    return timeSuggestionsEnabled;
}
